var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_vm._t("header"),_vm._v(" "),_c('main',{staticClass:"layout__content"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"layout__footer"},[_vm._t("footer")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }